<match-wrapper
    label="{{ label }}"
    objectType="{{ objectType }}"
    fieldName="{{ fieldName }}"
    (onRemoveMatch)="removeMatch()"
>
    <div
        class="http-status-match"
        provideParentForm
    >
        <enum-radio-buttons
            enum="MatchOperation"
            name="match-operation-{{ matchIndex }}"
            [(ngModel)]="editable.config.match_criteria"
        ></enum-radio-buttons>
        <div class="http-status-match__status-codes-wrapper">
            <avi-input-container
                noMarginTop
                helperText="{{ l10nKeys.statusMatchHelperText | vtranslate }}"
            >
                <label
                    aviLabelWithTooltip
                    objectType="{{ httpStatusMatchObjectType }}"
                    fieldName="status_codes"
                    for="status-codes"
                    required
                >
                    {{ globalL10nKeys.statusLabel | vtranslate }}
                </label>
                <avi-repeated-strings
                    id="status-codes"
                    name="status-codes"
                    placeholder="{{ l10nKeys.statusCodesPlaceholder | vtranslate }}"
                    objectType="{{ httpStatusMatchObjectType }}"
                    fieldName="status_codes"
                    [allowDuplicates]="false"
                    regexPattern="listOfStatusCodeOrRanges"
                    [(ngModel)]="statusCodesAndRanges"
                    (ngModelChange)="handleStatusCodesAndRangesChange()"
                    required
                ></avi-repeated-strings>
            </avi-input-container>
        </div>
    </div>
</match-wrapper>
